import { useInvoiceInfo } from '../InvoiceInfoProvider';
import BillingRow from './BillingRow';
import InvoiceActionsRow from './InvoiceActionsRow';
import InvoiceAuthorizeInfo from './InvoiceAuthorizeInfo';
import InvoiceInfoRow from './InvoiceInfoRow';
import SubscriptionInfoRow, { ServiceInfoRow } from './SubscriptionInfoRow';

function InfoContainer({ children, className }) {
    return (
        <div
            className={`rounded-[20px] shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] p-5 mb-4 ${className}`}
        >
            {children}
        </div>
    );
}

function InvoiceInfoRightCol({ invoiceData, billingAddress, invoiceItems }) {
    const { openModal } = useInvoiceInfo();
    return (
        <div>
            {invoiceData?.status === 'canceled' ? (
                <div className="flex p-2 py-3 gap-2 items-start bg-error/10 mb-3 rounded-10">
                    <span className="capitalize text-white rounded-5 bg-error p-1 py-0">
                        {invoiceData?.status}
                    </span>
                    <span className="text-error">{invoiceData?.note}</span>
                </div>
            ) : null}
            <InfoContainer>
                <InvoiceActionsRow invoiceData={invoiceData} noItems={invoiceItems?.length === 0} />
            </InfoContainer>
            {(invoiceData?.authorizedBy > 0 || invoiceData?.haveAuthorizePermission === true) &&
            invoiceData?.status !== 'canceled' &&
            invoiceData?.isQuotation === false ? (
                <InfoContainer>
                    <InvoiceAuthorizeInfo invoiceData={invoiceData} />
                </InfoContainer>
            ) : null}
            <InfoContainer>
                <InvoiceInfoRow invoiceData={invoiceData} billingAddress={billingAddress} />
            </InfoContainer>

            <InfoContainer>
                <BillingRow openModal={openModal} invoiceData={invoiceData} />
            </InfoContainer>
            {invoiceItems?.filter((item) => item?.productType === 'subscription').length ? (
                <InfoContainer className="min-h-52">
                    <SubscriptionInfoRow
                        openModal={openModal}
                        invoiceItems={invoiceItems}
                        invoiceData={invoiceData}
                    />
                </InfoContainer>
            ) : (
                <InfoContainer className="min-h-52">
                    <ServiceInfoRow
                        openModal={openModal}
                        invoiceItems={invoiceItems}
                        invoiceData={invoiceData}
                    />
                </InfoContainer>
            )}
        </div>
    );
}

export default InvoiceInfoRightCol;
